export default {"src":"/_next/static/media/getpacked.0d5202d9.svg","height":32,"width":37};